import { alpha } from '@material-ui/core/styles/colorManipulator';

const HEIGHT = 36;

export default (theme) => {
  const { background, borderColor, primary, text, textColor } = theme.palette;
  const border = `1px solid ${borderColor.primary}`;
  const button = {
    margin: 0,
    padding: 0,
    border: 0,
    background: 'none',
    font: 'inherit',
    color: textColor.dark,
    cursor: 'pointer',
    '&:disabled': {
      color: text.disabled,
      cursor: 'default',
    },
  };

  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      height: HEIGHT,
      minWidth: 0,
      padding: '0 6px 0 10px',
      overflow: 'hidden',
      border,
      borderRadius: 5,
      background: background.default,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      whiteSpace: 'nowrap',
      userSelect: 'none',
      outline: 'none',
      '&[role=button]': {
        cursor: 'pointer',
      },
      '&:focus-visible': {
        borderColor: primary.main,
      },
    },
    icon: {
      display: 'flex',
      color: textColor.secondary,
      '& svg': {
        fontSize: 18,
      },
    },
    value: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      gap: 4,
      minWidth: 0,
      marginLeft: 8,
      fontWeight: 400,
      color: textColor.dark,
    },
    unit: {
      color: text.secondary,
    },
    chevron: {
      flexShrink: 0,
      fontSize: 20,
      color: textColor.dark,
    },
    open: {
      borderColor: primary.main,
      '& $value, & $unit, & $chevron': {
        color: primary.main,
      },
    },
    error: {
      borderColor: borderColor.red,
    },
    disabled: {
      '& $value, & $unit, & $chevron': {
        color: text.disabled,
      },
    },
    part: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      gap: 3,
    },
    partSpaced: {
      paddingRight: 8,
    },
    panel: {
      boxSizing: 'border-box',
      width: 318,
      marginTop: 4,
      padding: 16,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      color: textColor.dark,
      '&.MuiPaper-rounded': {
        borderRadius: 8,
      },
    },
    title: {
      marginBottom: 14,
      fontWeight: 500,
    },
    controls: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 14,
    },
    control: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },
    caption: {
      fontSize: 12,
      color: textColor.secondary,
    },
    stepper: {
      display: 'flex',
      boxSizing: 'border-box',
      width: 80,
      height: HEIGHT,
      overflow: 'hidden',
      border,
      borderRadius: 5,
      '&:focus-within': {
        borderColor: primary.main,
      },
    },
    stepperInput: {
      flex: 1,
      minWidth: 0,
      margin: 0,
      padding: '0 0 0 12px',
      border: 0,
      outline: 'none',
      background: 'none',
      font: 'inherit',
      fontWeight: 400,
      color: textColor.dark,
    },
    arrows: {
      display: 'flex',
      flexDirection: 'column',
      width: 24,
      borderLeft: border,
      '@media (pointer: coarse)': { display: 'none' },
    },
    arrow: {
      ...button,
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 0,
      '& svg': {
        fontSize: 16,
      },
    },
    toggle: {
      display: 'flex',
      height: HEIGHT - 6,
      margin: '3px 0',
    },
    toggleItem: {
      ...button,
      position: 'relative',
      padding: '0 13px',
      border,
      fontWeight: 500,
      '&:first-child': {
        borderRadius: '5px 0 0 5px',
      },
      '&:last-child': {
        marginLeft: -1,
        borderRadius: '0 5px 5px 0',
      },
    },
    toggleOn: {
      zIndex: 1,
      borderColor: primary.main,
      background: alpha(primary.main, 0.1),
      color: primary.main,
    },
    quick: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      marginTop: 16,
      paddingTop: 16,
      borderTop: border,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 7,
    },
    chip: {
      ...button,
      height: 24,
      padding: '0 12px',
      border,
      borderRadius: 4,
      fontSize: 12,
      color: text.secondary,
      '&:hover': {
        borderColor: primary.main,
        color: primary.main,
      },
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 12,
      marginTop: 16,
      '& > .MuiButton-root': {
        minWidth: 88,
      },
    },
  };
};
